var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCadreImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 68,
    viewBox: "0 0 59 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter0_d_24_7931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.465 27.748H22.5593C16.7278 28.2806 12.1602 33.1827 12.1602 39.154C12.1602 44.8568 16.328 45.1373 21.7857 45.1373C22.3807 45.1373 22.9916 45.1338 23.615 45.1338H35.4123C36.0323 45.1338 36.6442 45.1373 37.2392 45.1373C42.6969 45.1373 46.8657 44.8573 46.8657 39.154C46.8652 33.1822 42.2961 28.2801 36.465 27.748Z",
    fill: "#2B9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6182 16.1319C19.6182 21.5961 24.0486 26.0265 29.5127 26.0265C34.9779 26.0265 39.4083 21.5961 39.4083 16.1319C39.4083 16.0476 39.4038 15.9637 39.4018 15.8799H19.6247C19.6227 15.9637 19.6182 16.0471 19.6182 16.1319Z",
    fill: "#2B9FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9557 14.159H40.0691C40.8922 14.159 41.559 13.4921 41.559 12.6695C41.559 11.8469 40.8922 11.1806 40.0691 11.1806H39.6638C39.6638 7.22386 37.3982 3.79873 34.0963 2.1236L33.2543 6.89343C33.1884 7.27128 32.8589 7.53733 32.4881 7.53733C32.4437 7.53733 32.3982 7.53333 32.3528 7.52535C31.9295 7.44998 31.647 7.04667 31.7229 6.62289L32.6822 1.17472C32.3224 0.598209 31.6835 0.213867 30.9527 0.213867H28.0716C27.3419 0.213867 26.703 0.598209 26.3426 1.17472L27.303 6.62339C27.3778 7.04667 27.0953 7.44998 26.672 7.52585C26.6266 7.53383 26.5812 7.53783 26.5368 7.53783C26.1654 7.53783 25.8365 7.27228 25.7701 6.89393L24.929 2.12509C21.6262 3.79873 19.3616 7.22386 19.3616 11.1806H18.9557C18.1332 11.1806 17.4668 11.8469 17.4668 12.6695C17.4668 13.4921 18.1332 14.159 18.9557 14.159Z",
    fill: "#2B9FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_7931",
    x: 0.929388,
    y: 0.213867,
    width: 57.1676,
    height: 67.3854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.2308
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.61538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.623529 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_7931"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_7931",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadreImg);
export default __webpack_public_path__ + "static/media/cadreImg.3e13f33196139faaf99742643839c2b0.svg";
export { ForwardRef as ReactComponent };